import React, { useState } from "react"
import styled from "@emotion/styled"
import { difYear, difMarca, difPlan } from "../helper"

const Campo =  styled.div`
    display: flex;
    margin-bottom: 1rem;
    align-items: center;
`

const Label = styled.label`
    flex: 0 0 100px;
    font-family: 'Quicksand', sans-serif;
`

const Select = styled.select`
    display: block;
    width: 100%;
    padding: 1rem;
    border: 1px solid #ff897d;
    border-radius: 0.375rem;
    -webkit-appearance: none;
    outline: none;
`

const InputRadio =  styled.input`
    margin: 0 1rem;
`

const Boton = styled.button`
    background-color: #c63637;
    padding: 1rem;
    font-size: 20px;
    font-weight: 500;
    width: 100%;
    color: #FFF;
    font-family: 'Ubuntu Condensed', sans-serif;
    text-transform: uppercase;
    border: 1px solid;
    border-radius: 0.375rem;
    transition: background-color .3s ease;
    margin-top: 2rem;
    &:hover {
        cursor: pointer;
        background-color: #ee6159;
    }
`

const Error = styled.div`
    background-color: #d1052a;
    font-family: 'Ubuntu Condensed', sans-serif;
    font-size: 23px;
    color: wheat;
    padding: 1rem;
    width: 100%;
    text-align: center;
    margin-bottom: 2rem;
    border-radius: 0.5rem;

`

const Form = ({setResumen, setIsLoading}) => {

    const [data, setData] =  useState({
        marca:"",
        year:"",
        plan:""
    })

    const [error, setError] = useState(false)


    const handleChange = e => {
        setData({
            ...data,
            [e.target.name] : e.target.value
        })
    }

    const handleSubmit = e => {
        e.preventDefault()

        if (data.marca.trim() === "" || data.year.trim() === "" || data.plan.trim() === "") {
            setError(true)
            return
        }
        setError(false)

        const diferencia = difYear(data.year)

        let result = 2000
        result -= ((diferencia * 3) * result) / 100
        result = difMarca(data.marca) * result

        const incrementPlan = difPlan(data.plan)

        result = parseFloat(incrementPlan * result).toFixed(2)


        setIsLoading(true)

        setTimeout(() => {
            setIsLoading(false)

            setResumen({
                cotizacion: Number(result),
                data
            })
        }, 2500)
    }

    return (
        <form onSubmit={handleSubmit}>
        {error ? <Error>Todos los campos son obligatorios.</Error> :  null}
            <Campo>
                <Label>Marca</Label>
                <Select
                    name="marca"
                    value={data.marca}
                    onChange={handleChange}
                >
                    <option disabled value="">Seleccione...</option>
                    <option value="americano">Americano</option>
                    <option value="europeo">Europeo</option>
                    <option value="asiatico">Asiático</option>
                </Select>
            </Campo>
            <Campo>
                <Label>Año</Label>
                <Select
                    name="year"
                    value={data.year}
                    onChange={handleChange}
                >
                    <option disabled value="">Seleccione...</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                </Select>
            </Campo>
            <Campo>
                <Label>Plan</Label>
                <InputRadio onChange={handleChange} type="radio" name="plan" value="basico" checked={data.plan === "basico"} /> Básico
                <InputRadio onChange={handleChange} type="radio" name="plan" value="completo" checked={data.plan === "completo"} /> Completo
            </Campo>
            <Boton type="submit">Cotizar</Boton>
        </form>
    )
} 

export default Form